export default "__VITE_ASSET__12cd3334__"